import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from '@environment';

if (environment.production) {
  enableProdMode();
}

const bootstrap = () =>
  platformBrowserDynamic()
    .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] })
    .catch(err => console.error(err));

// Staging-only time travel - offset is configured in the API (TIME_OFFSET_DAYS)
fetch(`${environment.API_URL}/common/time-offset`)
  .then(res => res.json())
  .then(({ offsetDays }: { offsetDays: number }) => {
    const offsetMs = (Number(offsetDays) || 0) * 24 * 60 * 60 * 1000;
    if (!offsetMs) {
      return;
    }
    const RealDate = Date;
    globalThis.Date = new Proxy(RealDate, {
      construct: (target, args, newTarget) =>
        Reflect.construct(target, args.length ? args : [target.now() - offsetMs], newTarget),
      apply: () => new RealDate(RealDate.now() - offsetMs).toString(),
      get: (target, prop, receiver) =>
        prop === 'now' ? () => target.now() - offsetMs : Reflect.get(target, prop, receiver),
    });
  })
  .catch(() => {})
  .finally(bootstrap);
